import Checkpoint from './models/Checkpoint'
import { loadCheckpoint, updateCheckpoint, updateCheckpointSections, 
  storeCheckpointPoc, addStandardToCheckpoint, updateStandardSecureSetting,
  removeStandardFromCheckpoint
} from '@/api/super'

export default {

  namespaced: true,

  state: {
    checkpoint: new Checkpoint,
    riskLevels: [
      { value: 'none', label: 'None' },
      { value: 'low', label: 'Low' },
      { value: 'medium', label: 'Medium' },
      { value: 'high', label: 'High' },
      { value: 'critical', label: 'Critical' },
    ]
  },

  mutations: {
    ...Checkpoint.mutations()
  },

  actions: {
    loadCheckpoint: ({commit}, checkpointId) => new Promise((resolve, reject) => {
      loadCheckpoint(checkpointId, ({data}) => {
        commit('setCheckpoint', data)
        commit('poc/setPoc', data.poc || {}, { root: true })
        resolve()
      }, reject)
    }),
    updateCheckpoint: ({state}) => new Promise((resolve, reject) => {
      updateCheckpoint(state.checkpoint, resolve, reject)
    }),
    updateSections: ({state}) => new Promise((resolve, reject) => {
      updateCheckpointSections({
        id: state.checkpoint.id,
        sections: state.checkpoint.sections
      }, resolve, reject)
    }),
    storePoc: ({state}, poc) => new Promise((resolve, reject) => {
      storeCheckpointPoc({
        id: state.checkpoint.id,
        poc
      }, resolve, reject)
    }),
    addStandard: ({}, payload) => new Promise((resolve, reject) => {
      addStandardToCheckpoint(payload, resolve, reject)
    }),
    updateStandardSecureSetting: ({}, payload) => new Promise((resolve, reject) => {
      updateStandardSecureSetting(payload, resolve, reject)
    }),
    removeStandard: ({state, commit}, section) => new Promise((resolve, reject) => {
      removeStandardFromCheckpoint({
        sectionId: section.id,
        checkpointId: state.checkpoint.id
      }, () => {
        commit('removeSection', section)
        resolve()
      }, reject)
    })
  },

  getters: {
    checkpoint: state => state.checkpoint,
    riskLevels: state => state.riskLevels,
  }

}